import { FC, PropsWithChildren } from 'react';
import { Elevation } from '../../../../../../ReactSharedScripts/components/Elevation';
import SpreadsheetRowLink from '../Spreadsheet/SpreadsheetRowLink';
import classes from './styles/listTile.module.css';
import classNames from 'classnames';
import { isBadOrEmptyString } from '../../../../../../ReactSharedScripts/predicates/string';

const ListTile: FC<PropsWithChildren<{ href?: string; disabled?: boolean }>> = ({ children, href, disabled }) => {
	const componentClasses = classNames(classes.root, {
		[classes.root_hasLink]: !isBadOrEmptyString(href),
	});

	return (
		<SpreadsheetRowLink
			href={href}
			className={componentClasses}
			disabled={disabled}
		>
			<Elevation
				style={{
					width: '100%',
					display: 'flex',
					minHeight: '210px',
				}}
			>
				{children}
			</Elevation>
		</SpreadsheetRowLink>
	);
};

export { ListTile };
